<template lang="pug">
  b-modal#jobControlLogInfo(
  ref="jobControlLogInfoModal"
  :title="$t('ui.job_control_log')"
  centered
  no-fade
  ok-only
  no-enforce-focus
  size="xl"
  :busy="loading"
  @shown="reset")
    div(v-if="detail")
      div(v-if="filteredOldDetailList.length > 0")
        b-form-group(:label="$t('ui.old')").mb-2
          div.row.mb-3.animated.fadeIn
            div.col
              .clusterize-scroll(style="max-height: 30vh !important;")
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th
                        span {{ $tc("ui.sports", 1) }}
                      th
                        span {{ $t("ui.bet_type") }}
                      th
                        span {{ $tc("ui.providers", 1) }}
                  tbody.clusterize-content
                    tr(v-for="item in filteredOldDetailList")
                      td
                        span.text-uppercase {{ item.sport_type }}
                      td
                        span.text-uppercase {{ item.bet_type }}
                      td
                        span {{ item.provider_id }}
      div(v-if="filteredNewDetailList.length > 0")
        b-form-group(:label="$t('ui.new')").mb-2
          div.row.mb-3.animated.fadeIn
            div.col
              .clusterize-scroll(style="max-height: 30vh !important;")
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th
                        span {{ $tc("ui.sports", 1) }}
                      th
                        span {{ $t("ui.bet_type") }}
                      th
                        span {{ $tc("ui.providers", 1) }}
                  tbody.clusterize-content
                    tr(v-for="item in filteredNewDetailList")
                      td
                        span.text-uppercase {{ item.sport_type }}
                      td
                        span.text-uppercase {{ item.bet_type }}
                      td
                        span {{ item.provider_id }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";

export default {
  components: {
    SubmitButton
  },
  props: {
    detail: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      recordList: []
    };
  },
  computed: {
    filteredOldDetailList() {
      if (this.recordList.length > 0) {
        return this.recordList.filter((item) => {
          return item.type.toLowerCase() == 'old';
        });
      } else
        return [];
    },
    filteredNewDetailList() {
      if (this.recordList.length > 0) {
        return this.recordList.filter((item) => {
          return item.type.toLowerCase() == 'new';
        });
      } else
        return [];
    },
  },
  methods: {
    getRecord() {
      let url = config.auditLogDetailRecordUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.auditlog,
        log_id: this.detail.log_id,
        log_detail_id: this.detail.log_detail_id,
        audit_table_name: this.detail.audit_table_name
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.recordList = response.data.tbl_audit_log_detail_record;
              } else {
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset() {
      this.getRecord();
    },
  }
};
</script>

<style lang="scss" scoped>
</style>
